export enum PlanTypes {
    Harvest = 'Cosecha',
    Load = 'Carga',
    Road = 'Caminería'
}